import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [debeCambiarClave, setDebeCambiarClave] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      api.get('/auth/me').then(res => {
        setUser(res.data);
        setDebeCambiarClave(res.data.debe_cambiar_clave === true || res.data.debe_cambiar_clave === 1);
        localStorage.setItem('user', JSON.stringify(res.data));
      }).catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    setDebeCambiarClave(res.data.debe_cambiar_clave === true);
    return res.data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setDebeCambiarClave(false);
  };

  const refreshUser = async () => {
    const res = await api.get('/auth/me');
    setUser(res.data);
    setDebeCambiarClave(res.data.debe_cambiar_clave === true || res.data.debe_cambiar_clave === 1);
    localStorage.setItem('user', JSON.stringify(res.data));
  };

  // Permisos
  const hasRole = (...roles) => user && roles.includes(user.rol);
  const isAdmin = () => user?.rol === 'administrador';
  const isDirectora = () => user?.rol === 'directora_tecnica';
  const canEdit = () => !['consulta'].includes(user?.rol);
  const canSign = () => user?.permisos?.puede_firmar === true || user?.rol === 'directora_tecnica' || Number(user?.es_suplente_firma) === 1;
  const canSolicitarFirma = () => user?.permisos?.puede_solicitar_firma === true || isAdmin() || user?.rol === 'directora_tecnica';
  const canCreate = () => user?.permisos?.puede_crear_pnt !== false || isAdmin();
  const canUpload = () => user?.permisos?.puede_subir_archivos !== false || isAdmin();
  const canExport = () => user?.permisos?.puede_exportar !== false || isAdmin();

  return (
    <AuthContext.Provider value={{
      user, loading, debeCambiarClave,
      login, logout, refreshUser,
      hasRole, isAdmin, isDirectora, canEdit, canSign, canSolicitarFirma, canCreate, canUpload, canExport
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
